import { post, get, put, del } from "@/utils/request";

//个人中心-展示
export function personalCenterApi() {
  return get(`/api/dots-platform/personalCenter`);
}

//个人中心-加入团队详情
export function teamInfoApi(data) {
  return get(`/api/dots-platform/personalCenter/teamInfo?uid=${data}`);
}

//用户详细信息
export function userApi(data) {
  return get(`/api/dots-platform/user`);
}

//个人中心-绑定用户详情
export function bindingInfoApi(data) {
  return get(`/api/dots-platform/personalCenter/bindingInfo?uid=${data}`);
}

//用户列表
export function userListApi(data) {
  return get(`/api/dots-platform/user/list`, data);
}

//更新用户标签
export function updateTagApi(data) {
  return put(`/api/dots-platform/user/updateTag`, data);
}

//更新用户（用户）信息
export function updateUserApi(data) {
  return put(`/api/dots-platform/user`, data);
}

//更新用户（用户）信息
export function updateUserCheckApi() {
  return get(`/api/dots-platform/user/beforeCheck`);
}

//用户列表
export function checkIdcardApi(idcard, uid) {
  return get(`/api/dots-platform/user/checkIdcard?idcard=${idcard}&uid=${uid}`);
}

//绑定用户(父=》子)
export function bindingSonApi(data) {
  return post(`/api/dots-platform/user/bindingSon`, data);
}

//监护人-信息模块查询展示
export function guardianApi() {
  return get(`/api/dots-platform/user/guardian`);
}

//通过手机号/邮箱精确查找用户
export function getUserInfoByAccountApi(data) {
  return get(`/api/dots-platform/user/getUserInfoByAccountV2/${data}`);
}

//新增/修改监护人
export function bindingParentApi(data) {
  return post(`/api/dots-platform/user/bindingParent`, data);
}

//移除监护人
export function removeGuardianApi(data) {
  return del(`/api/dots-platform/user/removeGuardian?guardianId=${data}`);
}

//通过邀请码加入团队查询名称URL
export function showTeamApi(data) {
  return get(`/api/dots-platform/user/showTeam?invitationCode=${data}`);
}

//登录注册之前，验证url上的邀请码是否有效
export function checkInvitationCodeApi(data) {
  return get(`/api/dots-platform/special/checkInvitationCode?invitationCode=${data}`);
}

//通过邀请码加入团队
export function joinTeamApi(data) {
  return get(`/api/dots-platform/user/joinTeam?invitationCode=${data}`);
}

//生成邀请码
export function genCodeApi(data) {
  return get(`/api/dots-platform/invitation/genCode?type=2&exp=${data}`);
}

// 校验是否可以注销账号
export function canCancel(uid) {
  return get(`/api/dots-platform/user/canCancel?uid=${uid}`);
}

// 根据UID发送验证码
export function sendVerifyByUidApi(uid, verifyMethod) {
  return get(
    `/api/dots-platform/special/sendVerifyByUid?uid=${uid}&verifyMethod=${verifyMethod}`
  );
}
